import OBase from './OBase';
import * as Geometry from '../geometry';
import * as GHMath from '../../math';

export default class ELine extends OBase {
  update () {
    let pointSTree = this.getVector3Input('Start Point', false);
    let pointETree = this.getVector3Input('End Point', false);

    let output = this.outputs['Line'].paramObject;

    let dataTrees = [pointSTree, pointETree];
    let outDataTrees = [];

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let start = outDataTrees[0].branches[i][j];
        let end = outDataTrees[1].branches[i][j];
        let curve = [new ClipperLib.DoublePoint(start.x, start.y), new ClipperLib.DoublePoint(end.x, end.y)];
        outTree.add([curve], outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ELine.js